import React from 'react'

import ScrollableTabs, {
  ScrollableTabsProps,
} from '@/components/misc/ScrollableTabs'
import PageTitle from '@/components/typography/PageTitle'

type Props = Omit<React.ComponentProps<'header'>, 'title'> & {
  title?: React.ReactNode
  titleIcon?: React.ComponentProps<typeof PageTitle>['icon']
  subtitle?: React.ReactNode
  tabs?: ScrollableTabsProps['tabs']
  tabProps?: ScrollableTabsProps['tabProps']
  titleAction?: React.ReactNode
}

const PageHeader: React.FC<Props> = ({
  title,
  titleIcon,
  subtitle,
  tabs,
  tabProps,
  titleAction,
  ...props
}) => {
  const shouldShowTitleOrSubtitle = !!(title || subtitle)

  return (
    <header {...props}>
      {shouldShowTitleOrSubtitle && (
        <div className="flex flex-col gap-1 mb-6">
          <div
            className="flex flex-col items-start gap-2 sm:flex-row
              sm:items-center sm:justify-between sm:gap-4"
          >
            {title && (
              <PageTitle
                className="mb-0"
                icon={titleIcon}
                wrapperProps={{ className: 'mb-0' }}
              >
                {title}
              </PageTitle>
            )}
            {titleAction}
          </div>
          {subtitle && (
            <p className="text-muted-foreground text-sm">{subtitle}</p>
          )}
        </div>
      )}

      {tabs && <ScrollableTabs tabs={tabs} tabProps={tabProps} />}
    </header>
  )
}

export default PageHeader
